/* eslint-disable no-nested-ternary */
import { useAuth } from '@context';
import { UserRoleService } from '@services';
import { SharedNoticeboard } from './components';

export function Noticeboard() {
  const { user } = useAuth();
  const { isWarehouseClient, isWarehouseManager } = UserRoleService();

  return isWarehouseClient(user) ? (
    <SharedNoticeboard isLsp={false} />
  ) : isWarehouseManager(user) ? (
    <SharedNoticeboard isLsp />
  ) : null;
}
